import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const KeyboardUtil = require('../../util/keyboard');
const ValidateUtil = require('../../util/ValidateUtil');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
import ErrorBox from '../common/ErrorBox';
import OrgRoleDropdown from '../common/OrgRoleDropdown';

const propTypes = {
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    orgId: PropTypes.number.isRequired,
};

const defaultProps = {
    show: false,
};

class NewOrgMemberModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationMemberStoreState: OrganizationMemberStore.getState(),
            memberEmail: "",
            roleToken: Globals.users.roles.ORG_MEMBER,
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onRoleChange = this.onRoleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.unsubscribes = [
            OrganizationMemberStore.listen(this.onOrganizationMemberStoreChange.bind(this)),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrganizationMemberStoreChange(state) {
        if (state.action.id === this.state.actionID) {
            if (!state.action.error) {
                this.props.closeHandler();
                return;
            }
        }

        const additionalState = ValidateUtil.getUpdatedState(this.state.actionID, state);
        this.setState({ organizationMemberStoreState: state, ...additionalState });
    }

    submitHandler(projectName) {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            OrganizationActions.setOrganizationPermission(
                actionID,
                {
                    orgId: this.props.orgId,
                    email: this.state.memberEmail,
                    role: this.state.roleToken,
                }
            );
        });
    }


    onEmailChange(e) {
        this.setState({ memberEmail: e.target.value });
    }

    onRoleChange(roleToken) {
        this.setState({ roleToken: roleToken });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler();
        }
    }

    render() {
        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>new organization member</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group controlId="new-org-mem-modal-input">
                            <Form.Label>email address</Form.Label>
                            <Form.Control
                                as="input"
                                type="email"
                                aria-label={this.props.ariaLabel}
                                value={this.state.memberEmail}
                                onChange={this.onEmailChange}
                                onKeyDown={this.handleKeyDown}
                                isInvalid={ValidateUtil.isInvalid(this.state, 'email')}
                            />
                        </Form.Group>
                        <label className="label-form" htmlFor="org-member-role">
                            organization role
                        </label>
                        <div>
                            <OrgRoleDropdown
                                className="margin-left-sm"
                                selectedRoleToken={this.state.roleToken}
                                onRoleChange={this.onRoleChange}
                                includeGuest
                            />
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!!this.state.actionID}
                        onClick={this.submitHandler}
                    >
                        add
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

NewOrgMemberModal.propTypes = propTypes;
NewOrgMemberModal.defaultProps = defaultProps;

export default NewOrgMemberModal;